export default "__VITE_ASSET__16551bbf__"